namespace GeniuzPOS.Inventory {
    export interface IcStockAdjInData extends Serenity.ListRequest {
        Header?: IcStockAdjustInRow;
        Adjcode?: IcStkAdjCodeRow;
        Details?: IcStockAdjustInDtRow[];
        SysDocNo?: string;
        Para?: Administration.CsParaRow;
        URLpic?: string;
        BizName?: string;
        BizAddressLine1?: string;
        BizAddressLine2?: string;
        BizAddressLine3?: string;
        TaxId?: string;
    }
}
